import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks";

const PrivateRoutes = () => {
  const token = useAppSelector((state) => state.user.token);
  const logoutClickedValue = useAppSelector(
    (state) => state?.user?.logoutClickedValue
  );
  const userStatus = useAppSelector(
    (state) => state?.user?.data?.currentStatus
  );
  const { pathname, search } = useLocation();

  function isMobileDevice() {
    const userAgent = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  }

  const vacationPause = localStorage?.getItem("vacationPause");
  const suspendnonpay = localStorage?.getItem("suspendnonpay");
  if (logoutClickedValue) {
    localStorage.removeItem("redirectPath");
    localStorage.removeItem("redirectPathSuspendnonpay");
    localStorage.removeItem("redirectPathVacationpause");
    localStorage.removeItem("suspendnonpay");
    localStorage.removeItem("vacationPause");
  } else if(process.env.REACT_APP_DEEPLINKING_BLOCK_MOBILE_AGENTS === "true" && isMobileDevice()) {
    // For Mobile device - Deeplinking is removed with Mobile device
    localStorage.removeItem("redirectPath");
  } else {
    if(pathname?.includes("/update-plan") || pathname?.includes("/shop-exp")|| pathname?.includes("/shop-review-order") || pathname?.includes("/change-plan-failed") || pathname?.includes("plan-details?orderNumber")) {
      localStorage?.setItem("redirectPath", '/account-settings/plan-details');
       if(userStatus && userStatus?.toUpperCase() !=="ACTIVE") {      
        return <Navigate to="/account-settings/plan-details" />
      }
    }else if(pathname?.includes("/error") || pathname?.includes("/network-info") || pathname?.includes("/help-and-support")){
      localStorage?.setItem("redirectPath", '/home');      
    }else if(suspendnonpay){
      localStorage?.setItem("redirectPathSuspendnonpay", '/my-bills/view-payments?suspendnonpay');
    }else if(vacationPause){
      localStorage?.setItem("redirectPathVacationpause", '/pause-service?vacationPause');
    }else {
      localStorage?.setItem("redirectPath", pathname + search);
    }
  }
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
